<template>
  <div class="qa">
    <div class="container">
      <div>
        <Title />
        <div class="row justify-content-between">
          <Breadcrumb />
          <div class="col-12 col-sm text-end mb-3 mb-sm-0">
            <button
              type="button"
              class="btn btn-transparent me-3"
              @click="getData"
            >
              取消
            </button>
            <button type="button" @click="save" class="btn btn-light">
              儲存
            </button>
          </div>
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-body">
          <quill v-model="description" />
        </div>
      </div>
      <div class="text-end mb-3">
        <button type="button" class="btn btn-secondary me-3" @click="getData">
          取消
        </button>
        <button type="button" @click="save" class="btn btn-gradient">
          儲存
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { onePage } from '@/http/api/onePage.js'
import { mapState, mapMutations, mapGetters } from 'vuex'
import quill from '@/components/plugin/Quill.vue'
import Title from '@/components/layout/Title.vue'
import Breadcrumb from '@/components/layout/Breadcrumb.vue'

export default {
  name: 'Qa',
  components: { quill, Title, Breadcrumb },
  data () {
    return {
      description: null
    }
  },
  computed: {
    ...mapState(['token']),
    ...mapGetters(['errMsgInfo'])
  },
  watch: {
    'token.headers.Authorization' (data) {
      if (data) {
        this.getData()
      }
    }
  },
  methods: {
    ...mapMutations([
      'AlertsInfo',
      'Alerted',
      'Loading',
      'Loaded',
      'SetRouterName',
      'SetErrMsg',
      'SetErrMsgKey'
    ]),
    getData () {
      const vm = this
      onePage
        .getQa(vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.description = data.data.content
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    save () {
      const vm = this
      vm.Loading()
      onePage.updateQa({ content: vm.description }, vm.token).then((res) => {
        const { data } = res
        if (res.status <= 201 && data.status === 'success') {
          vm.AlertsInfo({
            state: 'success',
            title: '成功',
            info: '更新資料成功'
          })
        } else {
          vm.SetErrMsg(data.errMsg)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗 ' + res.status,
            info: vm.errMsgInfo
          })
        }
        vm.Alerted()
        vm.Loaded()
      })
    }
  },
  created () {
    const vm = this
    vm.SetRouterName(vm.$route.name)
  },
  mounted () {
    const vm = this
    if (vm.token.headers.Authorization) {
      vm.getData()
    }
  }
}
</script>
